import { api } from 'services/api';
import { FeatureName } from 'types/entities/MobileSettings';

export default function useFlag(feature: FeatureName) {
  const { data, isLoading, isSuccess } = api.useGetMobileSettingsQuery();
  const disabledFeatureFlags = data?.disabledFeatureFlags;
  return isSuccess && !isLoading && !disabledFeatureFlags?.includes(feature);
}
